/* Bio content for the About page quote card */
export const bioParagraphs = [
  "Keigan works where most people stop looking. He's got a physics degree, he builds robots, he does energy healing sessions, and he starts companies on the side. Gravitational wave models, robotics systems, community platforms, parapsychology research — he's built all of it, often at the same time.",
];

export const bioLead = "Doesn't matter if he's writing code, running a healing session, wiring a new component, or reading up on consciousness research.";

export const bioEmphasis = "The throughline is always the same: a relentless curiosity about what lies just beyond the edge of what we think is possible.";

export const currentlyWorkingOn = [
  {
    emoji: "🛠️",
    prefix: "Building ",
    link: { text: "BackScratch", href: "https://backscratch.vercel.app/" },
    suffix: " — a barter platform for small businesses",
  },
  { text: "📈 Developing algorithmic trading strategies" },
  { text: "💚 Reiki & energy healing practice" },
  {
    emoji: "📱",
    prefix: "Content creation on ",
    link: { text: "Instagram", href: "https://www.instagram.com/keigancullen" },
    suffix: " — for the scientist & spiritual seeker alike",
  }
];

export const beyondTheWork = [
  "🍳 Cooks for everyone he loves",
  "🦅 Eagle Scout — still living by the code",
  "🤝 Networking and personal development on the regular",
];

export const bioQuote = "\"All that we see comes from the stars, the Earth, and each other.\"";
export const bioQuoteAuthor = "Keigan";
